import * as React from "react";
import { useStoreActions } from "../../../store/hooks";
import { useHistory } from "react-router-dom";
import { getAuthenticatedPath } from "../../../shared/routes";
import { BaseEditScreen } from "../../base/components/BaseEditScreen";
import { Customer } from "../models";
import { EditCustomerForm } from "../components/EditCustomerForm";

interface IProps {
    match: { params: { id: number | undefined } };
}

export const CustomerEditScreen: React.FC<IProps> = (props) => {
    const history = useHistory();

    const { getItems } = useStoreActions((actions) => actions.normalize);

    return (
        <BaseEditScreen<Customer>
            match={props.match}
            subState="customers"
            editComponent={(customer) => (
                <EditCustomerForm
                    customer={customer}
                    onClose={() => {
                        if (!customer) {
                            getItems({ subState: "customers" });
                        }
                        history.push(getAuthenticatedPath("customers"));
                    }}
                />
            )}
        />
    );
};
